export default function duplicateRecordWithRelations(param) {
  const id = param.id;
  this.load();
  const params = {action: "duplicate_mkt_record_with_relations", id: id, module: param.module};
  this.rest.post("customAction", params, (resp) => {
    if (resp.errCode === "OK"){
        this.href("#detail/" + resp.module + "/" + resp.id);
    } else {
        this.unLoad();
        this.alert(resp.errMsg);
    }
  });
}
